import React, { useEffect, useState, useContext, useRef } from 'react'
import axios from 'axios';
import { AuthContext } from '../helpers/AuthContex';
import { Button, Form, message, Badge, Table, InputNumber, Select, Input } from 'antd'
import Cookies from 'js-cookie';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { formatNumberWithCommas } from '../utils/Utils';
import { useCourseData } from './CourseDetail/hooks/useCourseData';
import { tableCSS, billtableCSS, formatNumber2point, checkNaN } from './CourseDetail/utils';
import CreateOrderModal from './CourseDetail/CreateOrderModal';
import BillModal from './CourseDetail/BillModal';
import DeleteOrderModal from './CourseDetail/DeleteOrderModal';
import { getOrderColumns, getOrderModalColumns, getBillingColumns, getExpandedRowColumns } from './CourseDetail/columns';

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

const CourseDetail = ({ patient_data }) => {
  const { authState } = useContext(AuthContext)
  const { id } = useParams()

  const {
    orders,
    services,
    employee,
    employeeoption,
    employeeoptionWithFilter,
    bills,
    options,
    Modifiedorder,
    loading: dataLoading,
    setLoading: setDataLoading,
    fetchData,
    setModifiedOrder,
    setOrders,
    setBills,
    setOptions
  } = useCourseData(id, authState);

  const [isLoading, setLoading] = useState(true);
  const [loading, setLoading2] = useState(false);

  useEffect(() => {
    setLoading(dataLoading);
  }, [dataLoading]);

  const [isModalOpen, setIsModalopen] = useState(false);
  const [isBillModalOpen, setIsBillModalOpen] = useState(false);

  const [selectedOption, setSelectedOption] = useState(null);
  const [cart, setCart] = useState([])
  const [totalPrice, setTotaPrice] = useState(0)
  const [cdiscount, setdiscount] = useState(0)
  const [finalprice, setfinalprice] = useState(0)

  const formRef = React.useRef(null);
  const [form] = Form.useForm();
  const [form3] = Form.useForm();
  const [bildata, setBildata] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isValid, setIsvalid] = useState(true);
  const [isPayOptionsSelected, setIsPayOptionsSelected] = useState(false)
  const [isEmployeeUnlock, setIsEmployeeUnlock] = useState(false)

  const [additionalDiscount, setAdditionalDiscount] = useState(0)
  const [isAddtionalDiscountValid, setIsAdditionalDiscountValid] = useState(true)

  const [isPay, setIsPay] = useState(false)

  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);
  const [confirmDeleteData, setConfirmDeleteData] = useState(null);

  const [formRef2] = Form.useForm();

  const [selectedUsedOptions, setSelectedUsedOption] = useState()

  const [isLastBillInOrder, setIsLastBillInOrder] = useState(false)

  const [messageApi, contextHolder] = message.useMessage();

  const showCreateOrderError = () => {
    messageApi.open({
      type: 'error',
      content: 'กรุณาตรวจสอบข้อมูลอีกครั้ง หรือมีข้อผิดพลาด',
    });
  };

  const handleModalCancle = async () => {
    try {
      const checkProductResponse = await axios.get(process.env.REACT_APP_API_URL + `/course/all-products-stock-status/${authState.department_id}`, { headers: { accessToken: Cookies.get('accessToken'), } })

      const stockStatusMap = checkProductResponse.data.reduce((map, product) => {
        map[product.service_id] = { status: product.status, quantity: product.quantity, };
        return map;
      }, {});

      const combinedOptions = services.reduce(
        (acc, item) => {
          const productData = item.service_type === 3 ? stockStatusMap[item.service_id] : null;
          const isAvailable = productData ? productData.status : false;
          const quantity = productData ? productData.quantity : 0;
          if (item.service_type === 1 && item.status !== 'inactive') {
            acc[0].options.push({ value: item.service_id, label: item.service_name, price: item.service_price, type: item.service_type, disabled: false, });
          } else if (item.service_type === 2 && item.status !== 'inactive') {
            acc[1].options.push({ value: item.service_id, label: item.service_name, price: item.service_price, type: item.service_type, disabled: false, });
          } else if (item.service_type === 3 && item.status !== 'inactive') {
            acc[2].options.push({ value: item.service_id, label: `${item.service_name} (จำนวนคงเหลือ: ${quantity})`, price: item.service_price, type: item.service_type, disabled: !isAvailable, });
          }
          return acc;
        },
        [
          { label: 'Services', options: [] },
          { label: 'Courses', options: [] },
          { label: 'Product', options: [] },
        ]
      );
      setOptions(combinedOptions)
    } catch (e) {
      console.error(e);
    }

    setIsModalopen(false)
    setCart([])
    setSelectedOption(null)
    setSelectedUsedOption();
    setfinalprice(0);
    setdiscount(0)
    setIsPayOptionsSelected(false)
    formRef.current?.resetFields();
    form3.resetFields();
    setTotaPrice(0);
    setIsEmployeeUnlock(false);
    setAdditionalDiscount(0);
    setIsAdditionalDiscountValid(true)
  }

  const handelBillModalCancle = () => {
    setIsBillModalOpen(false);
    setSelectedRow([]);
    setTotaPrice(0);
    setIsPayOptionsSelected(false);
    form3.resetFields();
    setIsEmployeeUnlock(false)
    setIsAdditionalDiscountValid(true);
    setAdditionalDiscount(0);
    setIsPay(false);
  }

  const handleCreateOrder = async () => {
    const sqlDate = form3.getFieldValue('date').format('YYYY-MM-DD HH:mm:ss')
    const currentDate = form3.getFieldValue('date')['$d'].toLocaleDateString('th-TH', { year: 'numeric', month: '2-digit', day: '2-digit' })

    setLoading(true)

    if (cart.length === 0) {
      handleModalCancle();
      setLoading(false)
      return;
    }

    try {
      // Check product stock first
      const checkQuantityInput = cart.map(item => ({
        id: item.id,
        quantity: item.times
      }));

      await axios.post(
        process.env.REACT_APP_API_URL + `/course/check-products-stock`,
        { services: checkQuantityInput },
        { headers: { accessToken: Cookies.get('accessToken') } }
      );

      // Prepare cart items with all calculated values
      let addDiscount = parseFloat(form3.getFieldValue('additional_discount') || 0);

      const cartItems = cart.map(item => {
        const discountToApply = Math.min(addDiscount, item.price_to_paid) || 0;
        addDiscount -= discountToApply;

        const totalPrice = formatNumber2point(item.times * item.price * (1 - parseFloat(item.discount) / 100)) - parseFloat(discountToApply || 0);
        const priceToPaid = parseFloat(item.price_to_paid) - parseFloat(discountToApply || 0);
        const discountValue = item.times * item.price * (parseFloat(item.discount) / 100) + parseFloat(discountToApply || 0);
        const discountId = formatNumber2point((discountValue * 100) / (item.times * item.price));

        const item_status = (parseFloat(totalPrice) - parseFloat(formatNumber2point(priceToPaid))) === parseFloat(formatNumber2point(0)) ?
          (parseInt(item.times) - parseInt(item.times_to_use || 0) === 0 ? 1 : 2) : 0;

        const item_remain = item.times_to_use ? parseInt(item.times) - parseInt(item.times_to_use) : item.times;

        return {
          id: item.id,
          times: item.times,
          type: item.type,
          totalPrice: totalPrice,
          priceToPaid: priceToPaid,
          discountValue: discountValue,
          discountId: discountId,
          discountToApply: discountToApply,
          item_status: item_status,
          item_remain: item_remain,
          inviter_id: item.inviter_id,
          inviter_percent: item.inviter_percent,
          healthcare_provider_id: item.healthcare_provider_id,
          times_to_use: item.times_to_use,
          use_options: item.use_options,
          handfee_times: item.handfee_times,
          tempPrice: item.tempPrice
        };
      });

      // Prepare request data for unified API
      const requestData = {
        cartItems: cartItems,
        billData: {
          bill_type: 1,
          payment_method: form3.getFieldValue('payment_method'),
          additional_discount: form3.getFieldValue('additional_discount') || 0,
          remark: form3.getFieldValue('remark') || " ",
        },
        currentDate: currentDate,
        sqlDate: sqlDate,
        department_id: authState.department_id,
        patient_id: id
      };

      // Call the unified API endpoint
      const response = await axios.post(
        process.env.REACT_APP_API_URL + '/bill-payment/create-order-with-bill',
        requestData,
        { headers: { accessToken: Cookies.get('accessToken') } }
      );

      // Update the bills state with the returned data
      if (response.data.success) {
        setBills(response.data.billItems);
      }

      // Refresh all data
      await fetchData();
      await handleModalCancle();
      setLoading(false);

    } catch (error) {
      showCreateOrderError()
      setLoading(false);
      console.error('Error in order creation process:', error.response ? error.response.data : error.message);
    }
  }

  const checkCart = () => {
    return cart.length > 0 && isValid && isPayOptionsSelected && isAddtionalDiscountValid;
  }

  const calculateTempPrice = () => {
    const timesValue = form.getFieldValue('times');
    const priceValue = form.getFieldValue('price');
    const discountValue = form.getFieldValue('discount');
    const tempPriceValue = checkNaN(formatNumber2point(timesValue * priceValue * (1 - discountValue / 100)));
    form.setFieldsValue({ tempPrice: tempPriceValue, price_to_paid: tempPriceValue });
  };

  const calculateTempPriceForpercentage = () => {
    const timesValue = form.getFieldValue('times');
    const priceValue = form.getFieldValue('price');
    const discountValue = form.getFieldValue('discount');
    const tempPriceValue = checkNaN(formatNumber2point(timesValue * priceValue * (1 - discountValue / 100)));
    const test = checkNaN(formatNumber2point(timesValue * priceValue * (discountValue / 100)))
    form.setFieldsValue({ tempPrice: tempPriceValue, price_to_paid: tempPriceValue, discountV: test });
  };

  const calculateTempPriceForValue = () => {
    const timesValue = form.getFieldValue('times');
    const priceValue = form.getFieldValue('price');
    // const discountValue = form.getFieldValue('discount'); // Unused
    const discountV = form.getFieldValue('discountV')

    const tempPriceValue = checkNaN(formatNumber2point((timesValue * priceValue) - discountV));
    const test = checkNaN((discountV * 100) / (timesValue * priceValue))

    form.setFieldsValue({ tempPrice: tempPriceValue, price_to_paid: tempPriceValue, discount: test });
  };

  const checkSelectedRow = () => {
    let priceValid = false;
    let employeeValid = false;

    for (const item of selectedRow) {

      if (parseInt(item.item_remain) === parseInt(item.times_to_use)) {
        if ((parseFloat(item.item_totalprice - item.item_paid) - parseFloat(item.price_to_paid)) !== 0) {
          priceValid = true;
        }
        else {
          priceValid = false
        }
      }
      if (!item.employee_id) {
        employeeValid = true;
      } else {
        if (item.employee_id.length > 0) {
          employeeValid = employeeValid || false;
        }
        else {
          employeeValid = true
        }
      }
    }
    return employeeValid || priceValid || !isPayOptionsSelected || !isAddtionalDiscountValid;
  };

  const billCreate = async () => {
    setLoading(true)
    const currentDate = form3.getFieldValue('date')['$d'].toLocaleDateString('th-TH', { year: 'numeric', month: '2-digit', day: '2-digit' })
    const sqlDate = form3.getFieldValue('date').format('YYYY-MM-DD HH:mm:ss')

    try {
      // Prepare data for the unified API
      const requestData = {
        selectedOrders: selectedRow,
        billData: {
          bill_type: 2,
          payment_method: form3.getFieldValue('payment_method'),
          additional_discount: 0,
          remark: form3.getFieldValue('remark') || " ",
        },
        currentDate: currentDate,
        sqlDate: sqlDate,
        department_id: authState.department_id,
        patient_id: id
      };

      // Call the unified API endpoint
      const response = await axios.post(
        process.env.REACT_APP_API_URL + '/bill-payment/create-bill-payment',
        requestData,
        { headers: { accessToken: Cookies.get('accessToken') } }
      );

      // Update the bills state with the returned data
      if (response.data.success) {
        setBills(response.data.billItems);
      }

      // Refresh all data
      await fetchData();

      // Clean up and close modal
      handelBillModalCancle()
      setIsBillModalOpen(false)
      setTotaPrice(0)
      setSelectedRow([])
      setLoading(false)

    } catch (error) {
      console.error('Error creating bill payment:', error);
      setLoading(false)
      // You might want to show an error message to the user here
      alert('เกิดข้อผิดพลาดในการสร้างบิล กรุณาลองใหม่อีกครั้ง');
    }
  };

  const handleDelete = (key) => {
    const newData = cart.filter((item) => item.id !== key);
    setCart(newData);
    setTotaPrice(newData.reduce((acc, item) => acc + item.times * item.price, 0))
    setdiscount(newData.reduce((acc, item) => acc + (item.times * item.price) * item.discount / 100, 0))
    setfinalprice(newData.reduce((acc, item) => acc + (item.times * item.price) - ((item.times * item.price) * item.discount / 100), 0))
    const updatedOptions = options.map((group) => {
      const updatedOptionsInGroup = group.options.map((item) => {
        if (item.value === key) {
          return { ...item, disabled: false };
        }
        return item;
      });
      return { ...group, options: updatedOptionsInGroup };
    });
    setOptions(updatedOptions);

  };

  const handleFinishedCourse = async (record) => {
    setLoading(true)
    const updatadata = async () => {
      try {
        const data = {
          id: record.id,
          item_status: 3,
        };
        await axios.put(process.env.REACT_APP_API_URL + `/course/update`, data, { headers: { accessToken: Cookies.get('accessToken'), } })
      } catch (error) {
        console.error('Error creating departments:', error);
      }

    };

    await updatadata();
    await fetchData();
    setLoading(false)
  }

  const handleDeleteCourse = async (record, index) => {
    setConfirmDeleteData(record)
    setIsLastBillInOrder(index === 0);
    setSelectedRow([])
    setSelectedRowKeys([])
    setIsConfirmDeleteModalOpen(true)
  }

  const handleDeleteCancel = () => {
    formRef2.resetFields();
    setIsLastBillInOrder(false);
    setIsConfirmDeleteModalOpen(false)

  }

  const handleDeleteConfirm = async () => {
    setLoading(true)

    try {
      const password = formRef2.getFieldsValue();

      // Call the unified delete-bill endpoint
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + '/bill-payment/delete-bill',
        {
          data: {
            billItemId: confirmDeleteData?.id,
            employeeListLength: confirmDeleteData.employee_list.length,
            password: password
          },
          headers: { accessToken: Cookies.get('accessToken') }
        }
      );

      if (response.data.success) {
        await fetchData();
        handleDeleteCancel();
      }

      setLoading(false);
    } catch (error) {
      console.error('Error deleting bill:', error);

      if (error.response?.status === 401) {
        alert("รหัสผ่านไม่ถูกต้อง");
      } else {
        alert("เกิดข้อผิดพลาดในการลบบิล กรุณาลองใหม่อีกครั้ง");
      }

      setLoading(false);
    }
  }

  const column = getOrderColumns(handleFinishedCourse, authState);

  const ordercolumn = getOrderModalColumns(handleDelete, cart);

  const billingcolumn = getBillingColumns(selectedRow, setSelectedRow, employeeoption, employeeoptionWithFilter, isEmployeeUnlock);

  const handleSave = (row) => {
    const totalPrice = row.price * row.times;
    const newData = cart.map(item =>
      item.id === row.id ? { ...item, times: row.times, totalPrice: totalPrice } : item
    );

    setCart(newData);
    setTotaPrice(newData.reduce((acc, item) => acc + item.times * item.price, 0))

    setfinalprice(newData.reduce((acc, item) => acc + (item.times * item.price) - ((item.times * item.price) * item.discount / 100), 0))
  };

  const handleSaveBilling = (row) => {
    const newData = selectedRow.map(item =>
      item.id === row.id ? { ...item, price_to_paid: row.price_to_paid, times_to_use: row.times_to_use } : item
    );
    const ttp = newData.reduce((acc, item) => acc + parseFloat(item.price_to_paid), 0)
    setTotaPrice(ttp)
    setIsPay(ttp > 0 ? true : false)
    setSelectedRow(newData);

  };

  const columns = ordercolumn.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        setIsvalid,
        isValid,
      }),
    };
  });


  const columnsBilling = billingcolumn.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSaveBilling,
        setIsvalid,
        isValid,
      }),
    };
  });

  const onFinish = (values) => {
    const totalPrice = values.price * values.times;

    const test = { ...selectedOption, disabled: true };
    const newData = [...options];
    const index = newData.findIndex((item) => test.value === item.value);
    if (index !== -1) {
      const item = newData[index];
      newData.splice(index, 1, {
        ...item,
        ...test,
      });
    } else {
      newData.forEach((group) => {
        group.options = group.options.map((item) => {
          if (item.value === test.value) {
            return { ...item, disabled: true };
          }
          return item;
        });
      });
    }

    const valuesWithTotalPrice = { ...values, totalPrice: totalPrice, name: selectedOption.label, type: selectedOption.type, item_remain: values.times, times_to_use: values.times_to_use ? values.times_to_use : 0, healthcare_provider_id: values.healthcare_provider_id || [], handfee_times: values.handfee_times || 0 };
    const newItems = [...cart, valuesWithTotalPrice];
    formRef.current?.resetFields();
    const billitem = [...bildata, { id: values.id, name: selectedOption.label, amount: values.times, price: values.price, discount: values.discount, totalPrice: totalPrice }]

    setBildata(billitem)
    setCart(newItems);
    setSelectedOption(null)
    setTotaPrice(newItems.reduce((acc, item) => acc + item.times * item.price, 0))
    setdiscount(newItems.reduce((acc, item) => acc + (item.times * item.price) * item.discount / 100, 0))
    setfinalprice(newItems.reduce((acc, item) => acc + (item.times * item.price) - ((item.times * item.price) * item.discount / 100), 0))
    setOptions(newData)
    setSelectedUsedOption();

  };

  const select = (selectedValue, selectedOption) => {
    setSelectedOption(selectedOption)
    form.setFieldsValue({ times: 1, price: selectedOption.price, type: selectedOption.type, name: selectedOption.label, discount: 0, discountV: 0, price_to_paid: selectedOption.price });
  }

  const onSelectChange = (newSelectedRowKeys, newSelectedRow) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRow(newSelectedRow.map((item) => ({ ...item, price_to_paid: 0, times_to_use: 1, remain_price: parseFloat(item.item_totalprice) - parseFloat(item.item_paid), discount_value: item.discount_value })));
  };

  const rowSelection2 = {
    selectedRowKeys,
    selectedRow,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.item_status === 1,
    }),

  };

  const hasSelected = selectedRowKeys.length > 0;

  const start = () => {
    setLoading2(true);
    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoading2(false);
      setIsBillModalOpen(true);
    }, 1000);
  };

  const expandedRowRender = (record) => {
    const filteredBillItems = bills.filter((item) => parseInt(item.order_id) === record.id);
    const selectedBill = Modifiedorder.find((item) => record.id === item.id)
    const modifiedData = filteredBillItems.map(item => {
      return {
        ...item,
        relize_revenue: item.times_used * (selectedBill.item_totalprice / selectedBill.item_times).toFixed(2)
      }
    }
    )
    const ordercolumn = getExpandedRowColumns(handleDeleteCourse, authState, filteredBillItems);

    return <Table columns={ordercolumn} pagination={false} dataSource={modifiedData} className={billtableCSS} />;
  };

  const onCheckChange = (e) => {
    setIsEmployeeUnlock(e.target.checked)
    setSelectedUsedOption();
    form.resetFields();
  }

  return (
    <>    {contextHolder}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className='shadow-md md:p-[24px]  md:bg-[#E77B7C] md:shadow-2xl md:mx-[10rem] mx-[0.5rem] rounded-xl ' >
        <div className={`  md:px-[24px] px-[0.5rem] pt-[24px] bg-white md:shadow-2xl rounded-xl ${(Modifiedorder.length === 0) ? 'pb-[24px]' : null}`}>
          <Table dataSource={Modifiedorder.reverse()} columns={column} bordered className={tableCSS} rowSelection={{ ...rowSelection2 }} pagination={{ showPagination: 'always', pageSize: 6 }} size="small" rowKey={"key"}
            expandable={{
              expandedRowRender,
              defaultExpandedRowKeys: ['0'],
            }}
            scroll={{ x: 'max-content' }}
          />
        </div>
      </div>
      <div className=' flex gap-x-5 justify-center mt-[1rem]'>
        <Button onClick={() => { setIsModalopen(true) }} className='mb-10 bg-white' disabled={authState.department_id === 0}>+ เพิ่มรายการ</Button>

        <Button onClick={start} disabled={!hasSelected || authState.department_id === 0} loading={loading} className='mb-10 bg-white'>
          ตัดบิล
        </Button>
      </div>


      {/*Create Order*/}
      <CreateOrderModal
        isModalOpen={isModalOpen}
        handleModalCancle={handleModalCancle}
        handleCreateOrder={handleCreateOrder}
        checkCart={checkCart}
        isEmployeeUnlock={isEmployeeUnlock}
        onCheckChange={onCheckChange}
        form={form}
        formRef={formRef}
        onFinish={onFinish}
        option={options}
        select={select}
        calculateTempPrice={calculateTempPrice}
        employeeoption={employeeoption}
        employeeoptionWithFilter={employeeoptionWithFilter}
        calculateTempPriceForpercentage={calculateTempPriceForpercentage}
        calculateTempPriceForValue={calculateTempPriceForValue}
        selectedUsedOptions={selectedUsedOptions}
        setSelectedUsedOption={setSelectedUsedOption}
        cart={cart}
        columns={columns}
        form3={form3}
        setIsPayOptionsSelected={setIsPayOptionsSelected}
        setIsAdditionalDiscountValid={setIsAdditionalDiscountValid}
        setAdditionalDiscount={setAdditionalDiscount}
        totalPrice={totalPrice}
        cdiscount={cdiscount}
        finalprice={finalprice}
        additionalDiscount={additionalDiscount}
        authState={authState}
      />

      {/*Billing*/}
      <BillModal
        isBillModalOpen={isBillModalOpen}
        handelBillModalCancle={handelBillModalCancle}
        billCreate={billCreate}
        checkSelectedRow={checkSelectedRow}
        isEmployeeUnlock={isEmployeeUnlock}
        onCheckChange={onCheckChange}
        selectedRow={selectedRow}
        columnsBilling={columnsBilling}
        form3={form3}
        setIsPayOptionsSelected={setIsPayOptionsSelected}
        totalPrice={totalPrice}
        authState={authState}
      />

      {/*Delete Order*/}
      <DeleteOrderModal
        isConfirmDeleteModalOpen={isConfirmDeleteModalOpen}
        handleDeleteCancel={handleDeleteCancel}
        confirmDeleteData={confirmDeleteData}
        isLastBillInOrder={isLastBillInOrder}
        formRef2={formRef2}
        handleDeleteConfirm={handleDeleteConfirm}
      />

    </>

  )
}
export default CourseDetail